import { twJoin } from '@beerntea/pitcher-ui';
import { Logo } from '@components/Logo';
import { Menu, type MenuItem, type SocialItem, type SubMenuItem } from '@components/Menu/Menu';
import { useRef } from 'react';
import { Link } from 'react-router';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollToPlugin);
interface Props {
  menu: {
    navItems: MenuItem[];
    subMenu: SubMenuItem[];
    socials: SocialItem[];
  };
  affix: boolean;
}

export function Header({ menu, affix = false }: Props) {
  const logoRef = useRef<HTMLAnchorElement>(null);
  const bounds = useRef<HTMLAnchorElement>(null);

  useGSAP(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: 'body',
        start: window.innerHeight,
        end: window.innerHeight + 10,
        scrub: 1,
        markers: false,
      },
    });
    if (affix) {
      tl.fromTo(
        logoRef.current,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.3,
        },
      );
    } else {
      gsap.set(logoRef.current, { autoAlpha: 1 });
    }

    return () => {
      tl.kill();
    };
  }, [affix]);

  return (
    <header
      ref={bounds}
      className={twJoin(
        'tw-px-6 tw-h-20',
        'tw-flex tw-justify-between tw-items-center tw-fixed tw-w-full tw-top-0 tw-left-0 tw-z-header tw-mix-blend-exclusion',
        'tw-text-white',
        'tw-pointer-events-none',
      )}
    >
      <Link
        ref={logoRef}
        to="/"
        className={'tw-pointer-events-auto'}
      >
        <Logo />
      </Link>
      <Menu
        subMenu={menu.subMenu}
        navItems={menu.navItems}
        socials={menu.socials}
      />
    </header>
  );
}
